import { createLogger } from "./logger";
function installCommandQueue(name, queue) {
    const logger = createLogger(name);
    function executeCommand(command) {
        if (typeof command === "function") {
            logger?.logInfo("Executing command from queue");
            command.call(window, {});
        }
    }
    function executeQueue(q) {
        logger?.logInfo("Executing queue...");
        q.forEach((cmd) => executeCommand(cmd));
        logger?.logInfo("Installing immediate queue handler");
        Object.defineProperty(queue, "push", {
            enumerable: false,
            configurable: false,
            writable: false,
            value(cmd, ...rest) {
                Array.prototype.push.apply(this, rest);
                if (typeof cmd === "function") {
                    executeCommand(cmd);
                }
            },
        });
    }
    return { queue, executeQueue };
}
export default installCommandQueue;
//# sourceMappingURL=command-queue.js.map